var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2171 1.90234C5.61712 1.90234 1.88379 5.63568 1.88379 10.2357C1.88379 14.8357 5.61712 18.569 10.2171 18.569C14.8171 18.569 18.5505 14.8357 18.5505 10.2357C18.5505 5.63568 14.8171 1.90234 10.2171 1.90234ZM7.95879 13.8107L4.96712 10.819C4.64212 10.494 4.64212 9.96901 4.96712 9.64401C5.29212 9.31901 5.81712 9.31901 6.14212 9.64401L8.55046 12.044L14.2838 6.31068C14.6088 5.98568 15.1338 5.98568 15.4588 6.31068C15.7838 6.63568 15.7838 7.16068 15.4588 7.48568L9.13379 13.8107C8.81712 14.1357 8.28379 14.1357 7.95879 13.8107Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.1fa13347d71734c0270edf04b0abcace.svg";
export { ForwardRef as ReactComponent };